export const addressLookupKeys = {
    all: ['address-lookup'] as const,
    find: (text: string, container?: string) =>
        [...addressLookupKeys.all, 'find', text, container ?? null] as const,
    // No `retrieve` key: Retrieve is a mutation, not a cached query.
};
